import { LocalizedEnum } from '@packages/components/localized-enum/localized-enum';
import type { GridRenderCellParams } from '@packages/fenrir/components/datagrid';

type EnumCellProps = GridRenderCellParams & {
  translationKey: string;
};

export const EnumCell = (params: EnumCellProps) => {
  return (
    <LocalizedEnum
      translationKey={params.translationKey}
      value={params.value}
    />
  );
};
